// extracted by mini-css-extract-plugin
export default {"root":"Button_root__gyozS","lg":"Button_lg__9XiBC","md":"Button_md__fsqcc","sm":"Button_sm__ht3gL"};